/**
 * 区分 activityType（activities.activity_type）
 * 出典：要件書 5.2・仕様書 SCR-022（online は D-044）
 */
export const ACTIVITY_TYPE_VALUES = ['visit', 'online', 'phone', 'email'] as const;

export type ActivityType = (typeof ACTIVITY_TYPE_VALUES)[number];

export const ACTIVITY_TYPE_LABELS: Readonly<Record<ActivityType, string>> = {
  visit: '訪問',
  online: 'オンライン',
  phone: '電話',
  email: 'メール',
};
